"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareDataEventString = exports.upperFirst = void 0;
function upperFirst(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}
exports.upperFirst = upperFirst;
var prepareDataEventString = function (data, order) {
    return order.map(function (current) {
        return "".concat(current, ":").concat(data[current.toString()]);
    }).join('|');
};
exports.prepareDataEventString = prepareDataEventString;
